import React from "react";
import { useMaterialModel } from "../materialModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export function PageHeader() {
    const { getTreeSelectOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useMaterialModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品编码",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品名称",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: [{ label: "启用", value: "1" }, { label: "禁用", value: "0" }]
        },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "商品类型",
            fieldName: "typeCode",
            treeData: getTreeSelectOne(DictCodeEnmu.MATERIAL_TYPE),
        }
    ]

    return (
        <YhPageHeader
            title="商品管理"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}